import SegurosApi from '../../apis/Seguros'

export default {
    namespaced: true,
    state: {
        seguros: [],
        segurosActivo: []
    },
    mutations: {
        set_seguros (state, seguros) {
            state.seguros = seguros
        },
        set_segurosActivos (state, segurosActivo) {
            state.segurosActivo = segurosActivo
        }
    },
    actions: {
        async getSeguros({commit, dispatch}, filters) {
            return await SegurosApi.get_all(filters)
                            .then( response => {
                                commit('set_seguros', response.data)
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al listar registros, vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async store({dispatch}, seguro) {
            return await SegurosApi.store(seguro)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'El registro se realizó de forma correcta.'
                                }, {root: true})
                                dispatch('getSeguros')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al registrar, vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async update({dispatch}, seguro) {
            return await SegurosApi.update(seguro)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La actualización se realizó de forma correcta'
                                }, {root: true})
                                dispatch('getSeguros')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al actualizar, vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async change_status({dispatch}, seguro) {
            let action = (seguro.activo) ? 'inactivación' : 'activación'
            return await SegurosApi.change_status(seguro)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La '+ action + ' se relizó de forma correcta.'
                                }, {root: true})
                                dispatch('getSeguros')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al realizar la ' + action + ', vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async delete({dispatch}, seguro) {
            return await SegurosApi.delete(seguro)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La eliminación se realizó de forma correcta.'
                                }, {root: true})
                                dispatch('getSeguros')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al eliminar, vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async seguroActivos({commit, dispatch}) {
            return await SegurosApi.listarActivos()
                            .then( response => {
                                commit('set_segurosActivos', response.data)
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al listar registros, vuelva a intentarlo.'
                                }, {root: true});
                            })
        }
    }
}